var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3285",
    d: "M15.6652 8.80719C16.1116 8.36074 16.1116 7.6357 15.6652 7.18925L9.95055 1.47464C9.5041 1.02819 8.77906 1.02819 8.33261 1.47464C7.88615 1.92109 7.88615 2.64613 8.33261 3.09259L12.1007 6.85708H1.14292C0.510743 6.85708 0 7.36783 0 8.00001C0 8.63218 0.510743 9.14293 1.14292 9.14293H12.0971L8.33618 12.9074C7.88973 13.3539 7.88973 14.0789 8.33618 14.5254C8.78263 14.9718 9.50767 14.9718 9.95413 14.5254L15.6687 8.81077L15.6652 8.80719Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b0ebbf968195bf17c9aeb05a3f00fc55.svg";
export { ForwardRef as ReactComponent };